import PropTypes from 'prop-types';

const Badge = ({ children, variant = 'neutral', size = 'medium', icon = null, className = '' }) => {
	const variantClasses = {
		neutral: 'bg-gray-50 text-gray-900 border-gray-200',
		info: 'bg-cyan-50 text-cyan-800 border-cyan-200',
		success: 'bg-green-50 text-green-900 border-green-200',
		warning: 'bg-amber-50 text-amber-800 border-amber-200',
		error: 'bg-red-50 text-red-900 border-red-200',
		primary: 'bg-primary text-on-primary border-primary',
		secondary: 'bg-secondary text-on-secondary border-secondary',
	};

	const sizeClasses = {
		small: 'px-2 py-0.5 text-xs',
		medium: 'px-2.5 py-1 text-sm',
		large: 'px-3 py-1.5 text-base',
	};

	return (
		<span
			className={`inline-flex items-center gap-1.5 rounded-md border font-medium w-fit ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
		>
			{icon && <i className={`${icon} leading-none`} />}
			{children}
		</span>
	);
};

Badge.propTypes = {
	children: PropTypes.node.isRequired,
	variant: PropTypes.oneOf(['neutral', 'info', 'success', 'warning', 'error', 'primary', 'secondary']),
	size: PropTypes.oneOf(['small', 'medium', 'large']),
	icon: PropTypes.string,
	className: PropTypes.string,
};

export default Badge;
